import { useAuth0 } from '@auth0/auth0-react';
import { useSoundPath } from 'hooks/useSoundPath';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { logOutAccount } from 'store/user';

const PageHeaderUserInfo = () => {
  const dispatch = useDispatch();
  const { logout } = useAuth0();

  const playSound = useSoundPath();

  const playSoundHandler = () => playSound('main');

  const logOutHandle = () => {
    playSoundHandler();
    dispatch(logOutAccount())
    logout({
      returnTo: '/dashboard',
      federated: true,
    });
  }

  return (
    <>
      <button className="page-header__user-info">
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.99984 1.83337C6.34298 1.83337 4.99984 3.17652 4.99984 4.83337C4.99984 6.49023 6.34298 7.83337 7.99984 7.83337C9.65669 7.83337 10.9998 6.49023 10.9998 4.83337C10.9998 3.17652 9.65669 1.83337 7.99984 1.83337Z"
            fill="currentColor" />
          <path
            d="M8.00034 8.50004C4.82849 8.50004 2.61144 10.8474 2.3366 13.771L2.26807 14.5H13.7326L13.6641 13.771C13.3892 10.8474 11.1722 8.50004 8.00034 8.50004Z"
            fill="currentColor" />
        </svg>
      </button>
      <section className="page-header__user-popup">
        <b className="page-header__user-popup-title">Account</b>
        <nav className="page-header__user-popup-actions">
          <Link to="/profile/me" onClick={playSoundHandler} className="page-header__user-popup-action">Profile</Link>
          <Link to="/profile/prediction-status" onClick={playSoundHandler} className="page-header__user-popup-action">Prediction Status</Link>
          <Link to="/profile/transactions" onClick={playSoundHandler} className="page-header__user-popup-action">Transactions</Link>
          <Link to="/profile/settings" onClick={playSoundHandler} className="page-header__user-popup-action">Settings</Link>
          {/* <Link to='/privacies/learn-to-play' className="page-header__user-popup-action page-header__user-popup-action--yellow">Learn To Play</Link> */}
          <Link onClick={logOutHandle} className="page-header__user-popup-action page-header__user-popup-action--logout">Log out</Link>
        </nav>
      </section>
    </>
  )
}

export default PageHeaderUserInfo;
